
import { mapActions } from 'vuex'
import Picture from '~/components/picture/lole-picture'
import CartEditQuantity from '~/components/cart/CartEditQuantity'
import CartProductPromoMessage from '~/components/cart/CartProductPromoMessage'
import Price from '~/components/price/price'
export default {
  components: { Picture, CartEditQuantity, Price, CartProductPromoMessage },
  inject: ['wording'],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    price() {
      let ttAlloc = 0
      if (
        this.product.discountAllocations &&
        this.product.discountAllocations.length > 0
      ) {
        this.product.discountAllocations.forEach(({ allocatedAmount }) => {
          ttAlloc = ttAlloc + parseFloat(allocatedAmount.amount)
        })
        return (this.product.price * this.product.quantity - ttAlloc).toString()
      } else {
        return (this.product.price * this.product.quantity).toString()
      }
    },
    strikeoutPrice() {
      if (
        this.product.discountAllocations &&
        this.product.discountAllocations.length > 0
      ) {
        return this.product.strikeoutPrice
          ? (this.product.strikeoutPrice * this.product.quantity).toString()
          : (this.product.price * this.product.quantity).toString()
      } else {
        return (this.product.strikeoutPrice * this.product.quantity).toString()
      }
    },
    allocationPrice() {
      if (
        this.product.discountAllocations &&
        this.product.discountAllocations.length > 0
      ) {
        let ttAlloc = 0
        this.product.discountAllocations.forEach(({ allocatedAmount }) => {
          ttAlloc = ttAlloc + parseFloat(allocatedAmount.amount)
        })
        return ttAlloc.toString()
      } else return null
    },
    allocationPourcentage() {
      if (
        this.product.discountAllocations &&
        this.product.discountAllocations.length > 0
      ) {
        let ttAlloc = 0
        this.product.discountAllocations.forEach(({ allocatedAmount }) => {
          ttAlloc = ttAlloc + parseFloat(allocatedAmount.amount)
        })
        const a = this.product.strikeoutPrice
          ? this.product.strikeoutPrice * this.product.quantity
          : this.product.price * this.product.quantity
        const b = this.product.price * this.product.quantity - ttAlloc
        return (100 - (b * 100) / a).toString()
      } else return null
    },
    isFinalSaleProduct() {
      return this.product?.isFinalSale
    },
  },
  watch: {
    product() {
      this.isLoading = false
    },
  },
  methods: {
    ...mapActions({
      vxUpdateProductsToCart: 'product/updateProductsToCart',
    }),
    updateQty(qty) {
      try {
        if (qty > this.product.quantity)
          this.$googleAnalyticsEvents.GA4IncUpdateAddToCart(
            this.product,
            qty - this.product.quantity
          )
        else
          this.$googleAnalyticsEvents.GA4DecUpdateAddToCart(
            this.product,
            this.product.quantity - qty
          )
      } catch (e) {
        this.$sentryException(e, {
          source: 'CartProduct - updateQty()',
          level: 'warning',
          extra: 'Error tracking GA4 : ' + e,
        })
      }
      this.vxUpdateProductsToCart({
        products: [
          {
            variant: { id: this.product.id },
            quantity: parseInt(qty),
          },
        ],
      })
    },
    deleteItem() {
      this.isLoading = true
      try {
        this.$googleAnalyticsEvents.GA4DecUpdateAddToCart(
          this.product,
          this.product.quantity
        )
      } catch (e) {
        this.$sentryException(e, {
          source: 'CartProduct - deleteItem()',
          level: 'warning',
          extra: 'Error tracking GA4 : ' + e,
        })
      }
      this.vxUpdateProductsToCart({
        products: [
          {
            variant: { id: this.product.id },
            quantity: 0,
          },
        ],
      })
    },
    getLinkProduct() {
      return this.product?.handle === 'gift-card'
        ? this.product?.handle
        : `/product/${this.product?.handle}`
    },
  },
}
